import React from 'react';
import SectionTitle from '../../../components/section-title';
import ScrollPositionAnimation from '../../../components/scrollpositionanimation';

const WhatUnderpinsUs = () => {
  return (
    <div className="what-uderpins">
      <div className="container">
        <div className="container-inner">
          <ScrollPositionAnimation targetElement1="anim-6">
            <div className="right-to-left anim-6">
              <SectionTitle lighttext="WHAT UNDERPINS US" boldtext="OUR CORE VALUES" isSectionH1={false}></SectionTitle>
              <div className="core-values">
                <ul>
                  <li>Trust</li>
                  <li>Care</li>
                  <li>Integrity</li>
                  <li>Entrepreneurship</li>
                  <li>Respect</li>
                  <li>Excellence</li>
                  <li>Innovation</li>
                </ul>
              </div>
            </div>
          </ScrollPositionAnimation>
        </div>
      </div>
    </div>
  );
};

export default WhatUnderpinsUs;
